import React, { Component } from 'react';
import { ModalBody, ModalHeader, Row, Col, Modal } from 'reactstrap';

class LockModal extends Component {
  state = {
    password: ''
  };

  updatePassword = event => {
    this.setState({
      password: event.currentTarget.value
    });
  };
  
  onSubmit = event => {
    if (event.which === 13) {
      this.props.unlock(this.state.password);
    };
  };

  unlock = () => {
    this.props.unlock(this.state.password);
  };

  render() {
    return (
      <Modal
        isOpen={this.props.modalActive}
        toggle={this.props.toggleModal}
        className={'modal-lg'}
      >
        <ModalHeader toggle={this.props.toggleModal}>
          Exclusive Chairman + Founder Level Member Experiences
        </ModalHeader>
        <ModalBody style={{ backgroundColor: '#ffffff' }} className={'p-0'}>
          <Row>
            <Col className={'py-4'}>
              <div className={'px-3 text-center pb-3'}>
                Forgot password? Contact <a href="mailto:guestservices@jetsuite.com" className={'color-red'}>Guest Services</a>
                <br />
                <span className={'font-sm color-nav-grey'}>
                  Enter password to unlock experiences
                </span>
              </div>
              <Row className={'justify-content-center'}>
                <Col xs={10} md={8}>
                  <input
                    className={
                      this.props.passwordValidation
                        ? 'form-control'
                        : 'form-control is-invalid-input'
                    }
                    value={this.state.password}
                    onChange={event => this.updatePassword(event)}
                    onKeyPress={event => this.onSubmit(event)}
                  />
                  {!this.props.passwordValidation && (
                    <span className={'error text-center'}>Wrong password</span>
                  )}
                </Col>
              </Row>
              <div className={'py-4 text-center'}>
                <button className={'btn btn-fullred'} onClick={this.unlock}>
                  UNLOCK
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}
export default LockModal;



// WEBPACK FOOTER //
// ./src/components/Experiences/LockModal/LockModal.js